/* eslint-disable react/button-has-type */
import { Button } from '@pwskills/rachnaui';
import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({
  isOpen,
  onClose,
  closeBtn,
  children,
  className,
}: {
  isOpen: boolean;
  onClose: () => void;
  closeBtn: boolean;
  children: React.ReactNode;
  className: string;
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node) && closeBtn) {
      onClose();
    }
  };

  useEffect(() => {
    const pushState = () => {
      window.history.pushState({ modalOpen: true }, '', window.location.href);
    };

    const handleBack = (e: PopStateEvent) => {
      if (isOpen && e.state && e.state.modalOpen) {
        pushState();
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      pushState();
      window.addEventListener('popstate', handleBack);
    } else {
      document.body.style.overflow = 'auto';
      window.removeEventListener('popstate', handleBack);
    }

    return () => {
      window.removeEventListener('popstate', handleBack);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed w-screen max-h-screen inset-0 m-auto z-[99999] flex items-center justify-center bg-[#000000a6] bg-opacity-10 cursor-default"
      onClick={handleBackdropClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleBackdropClick(e as unknown as React.MouseEvent<HTMLDivElement>);
        }
      }}
    >
      <div ref={modalRef} className={`bg-white shadow-lg relative overflow-hidden ${className} `}>
        {closeBtn && (
          <Button
            className="!block medium:!hidden absolute w-5 h-5 top-6 right-6 text-gray-900 bg-transparent  z-20"
            onClick={onClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
            >
              <path
                d="M8.28279 7.3253L13.7342 1.8737C14.089 1.5191 14.089 0.945752 13.7342 0.591148C13.3796 0.236544 12.8063 0.236544 12.4517 0.591148L7.00007 6.04275L1.54863 0.591148C1.19386 0.236544 0.620682 0.236544 0.266078 0.591148C-0.0886926 0.945752 -0.0886926 1.5191 0.266078 1.8737L5.71752 7.3253L0.266078 12.7769C-0.0886926 13.1315 -0.0886926 13.7048 0.266078 14.0595C0.442799 14.2363 0.67516 14.3252 0.907355 14.3252C1.13955 14.3252 1.37175 14.2363 1.54863 14.0595L7.00007 8.60785L12.4517 14.0595C12.6286 14.2363 12.8608 14.3252 13.093 14.3252C13.3252 14.3252 13.5573 14.2363 13.7342 14.0595C14.089 13.7048 14.089 13.1315 13.7342 12.7769L8.28279 7.3253Z"
                fill="#3D3D3D"
              />
            </svg>
          </Button>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
